
export enum EstoqueTipoEnum {
  TONELADA = 'tonelada',
  SACA = 'saca',
}

export enum EstoqueSiglaEnum {
  TONELADA = 't',
  SACA = 'sc',
}